import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { DefaultPriceBadgeProps } from "./DefaultPriceBadge.types"

const icon = faIcon({ name: "tag", style: "regular" })

export default function DefaultPriceBadge(props: DefaultPriceBadgeProps) {
    const { value, label, unitTypeLabel, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    // The badge is always shown — a missing price renders as the zero-currency value.
    const formatted = formatCurrency(value ?? 0)

    const isHourly = unitTypeLabel === "Hourly"
    const displayed = isHourly ? `${formatted}/hr` : formatted
    const tooltip = isHourly ? `${label}\n${formatted} per hour` : `${label}\n${formatted}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {displayed}
        </Badge>
    )
}
